import { MODULE_KEYS } from "@/config/modules-registry";

export const HRM_EMPLOYEES_MENU = "Employees";

export const HRM_EMPLOYEE_MENU_PERMISSIONS = {
  [HRM_EMPLOYEES_MENU]: "Employee.Read",
  Departments: "Department.Read",
  Sections: "Section.Read",
  Designations: "Designation.Read",
  "Organization Chart": "Employee.Read",
  "All Employees": "Employee.Read",
  "Employee Salary": "EmployeeSalary.Read",
  Policies: "Policy.Read",
};

export function isHrmEmployeesParentMenu(menuValue) {
  return (
    menuValue === HRM_EMPLOYEES_MENU ||
    menuValue === "Employee" ||
    menuValue === "Employee Details"
  );
}

export const HRM_PAYROLL_MENU_PERMISSIONS = {
  "Payroll Company Settings": "Payroll.Read",
  Payroll: "Payroll.Read",
  "Payroll Components": "Payroll.Read",
  "Payroll Deduction": "Payroll.Read",
  "Optional Monthly Adjustments": "Payroll.Edit",
  "Overtime Entries": "Payroll.Read",
  "Payroll Settings": "Payroll.Edit",
  "Meta Conversion": "Payroll.Edit",
  "Payroll Adjustments": "Payroll.Edit",
  "Payroll Presets": "Payroll.Edit",
  "My Payroll": "Payroll.ReadSelf",
  "My Payslips": "Payroll.ReadSelf",
  "My P9": "Payroll.ReadSelf",
};

export const HRM_ATTENDANCE_MENU_PERMISSIONS = {
  Attendance: "Attendance.Read",
  Leaves: "Leaves.Read",
  "Leaves (Admin)": "Leaves.Read",
  "Leave (Employee)": "Leaves.Read",
  "Leave Settings": "LeaveTypes.Read",
  "Attendance (Admin)": "Attendance.Read",
  "Attendance (Employee)": "Attendance.Read",
  Timesheets: "TimingSheets.Read",
  "My Timesheets": "TimingSheets.Read",
  "My Schedule": "Attendance.Read",
  "Shift & Schedule": "ShiftSchedule.Read",
  "Payroll Overtime": "Payroll.Read",
};

export const HRM_ATTENDANCE_ADMIN_ONLY_MENUS = [
  "Leaves (Admin)",
  "Leave Settings",
  "Attendance (Admin)",
  "Timesheets",
  "Shift & Schedule",
  "Payroll Overtime",
];

export function isHrmAttendanceAdminOnlyMenu(menuValue) {
  return HRM_ATTENDANCE_ADMIN_ONLY_MENUS.includes(menuValue);
}

export const HRM_PERFORMANCE_MENU_PERMISSIONS = {
  Performance: "PerformanceIndicator.Read",
  "Performance Indicator": "PerformanceIndicator.Read",
  "Performance Review List": "PerformanceReview.Read",
  "Performance Appraisal": "PerformanceAppraisal.Read",
  "Goal List": "GoalTracking.Read",
  "Goal Type": "GoalType.Read",
};

export const HRM_TRAINING_MENU_PERMISSIONS = {
  Training: "Training.Read",
  "Training List": "Training.Read",
  Trainers: "Trainer.Read",
  "Training Type": "TrainingType.Read",
};

export const HRM_TICKETS_MENU_PERMISSIONS = {
  Tickets: "Ticket.Read",
};

export const HRM_SINGLE_MENU_PERMISSIONS = {
  Promotion: "Promotion.Read",
  Resignation: "Resignation.Read",
  Termination: "Termination.Read",
  Holidays: "Holiday.Read",
};

export const HRM_EMPLOYEE_ROUTE_RULES = [
  {
    permission: "Department.Read",
    moduleKey: MODULE_KEYS.HRM_EMPLOYEE,
    matches: (path) => path === "/employee/departments" || path === "/employee/employee-department",
  },
  {
    permission: "Designation.Read",
    moduleKey: MODULE_KEYS.HRM_EMPLOYEE,
    matches: (path) => path === "/employee/designations" || path === "/employee/employee-designations",
  },
  {
    permission: "Employee.Read",
    moduleKey: MODULE_KEYS.HRM_EMPLOYEE,
    matches: (path) =>
      path === "/employee/employee-list" ||
      path === "/employee/employee-grid" ||
      path.startsWith("/employee/employee-details"),
  },
  {
    permission: "EmployeeSalary.Read",
    moduleKey: MODULE_KEYS.HRM_PAYROLL,
    matches: (path) => path === "/payroll/employee-salary",
  },
  {
    permission: "Section.Read",
    moduleKey: MODULE_KEYS.HRM_EMPLOYEE,
    matches: (path) => path === "/employee/sections",
  },
  {
    permission: "Policy.Read",
    moduleKey: MODULE_KEYS.HRM_EMPLOYEE,
    matches: (path) => path === "/employee/policy" || path.startsWith("/employee/employee-policy"),
  },
];

export const HRM_PAYROLL_ROUTE_RULES = [
  {
    permission: "Payroll.Read",
    moduleKey: MODULE_KEYS.HRM_PAYROLL,
    matches: (path) =>
      path === "/payroll/payroll" ||
      path === "/payroll/payroll-deduction" ||
      path === "/payroll/payroll-overtime" ||
      path === "/payroll/payroll-overtime-entries",
  },
  {
    permission: "Payroll.ReadSelf",
    moduleKey: MODULE_KEYS.HRM_PAYROLL,
    matches: (path) =>
      path === "/payroll/my-payslips" ||
      path === "/payroll/my-p9",
  },
  {
    permission: "Payroll.Edit",
    moduleKey: MODULE_KEYS.HRM_PAYROLL,
    matches: (path) =>
      path === "/payroll/payroll-settings" ||
      path === "/payroll/period-adjustments" ||
      path === "/payroll/payroll-meta-conversion" ||
      path === "/payroll/payroll-adjustments" ||
      path === "/payroll/payroll-presets",
  },
];

export const HRM_ATTENDANCE_ROUTE_RULES = [
  {
    permission: "Leaves.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    adminOnly: true,
    matches: (path) => path === "/leave/leaves-admin",
  },
  {
    permission: "Leaves.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    matches: (path) => path === "/leave/leaves-employee",
  },
  {
    permission: "LeaveTypes.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    adminOnly: true,
    matches: (path) => path === "/leave/leave-settings",
  },
  {
    permission: "Attendance.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    adminOnly: true,
    matches: (path) => path === "/attendance/attendance-admin",
  },
  {
    permission: "Attendance.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    matches: (path) => path === "/attendance/attendance-employee",
  },
  {
    permission: "TimingSheets.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    adminOnly: true,
    matches: (path) => path === "/attendance/timesheets",
  },
  {
    permission: "TimingSheets.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    matches: (path) => path === "/attendance/my-timesheets",
  },
  {
    permission: "Attendance.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    matches: (path) => path === "/attendance/my-schedule",
  },
  {
    permission: "ShiftSchedule.Read",
    moduleKey: MODULE_KEYS.HRM_ATTENDANCE,
    adminOnly: true,
    matches: (path) => path === "/attendance/schedule-timing",
  },
];

export const HRM_PERFORMANCE_ROUTE_RULES = [
  {
    permission: "PerformanceIndicator.Read",
    moduleKey: MODULE_KEYS.HRM_PERFORMANCE,
    matches: (path) => path === "/performance/performance-indicator",
  },
  {
    permission: "PerformanceReview.Read",
    moduleKey: MODULE_KEYS.HRM_PERFORMANCE,
    matches: (path) =>
      path === "/performance/performance-review-list" ||
      path === "/performance/performance-review",
  },
  {
    permission: "PerformanceAppraisal.Read",
    moduleKey: MODULE_KEYS.HRM_PERFORMANCE,
    matches: (path) => path === "/performance/performance-appraisal",
  },
  {
    permission: "GoalTracking.Read",
    moduleKey: MODULE_KEYS.HRM_PERFORMANCE,
    matches: (path) => path === "/performance/goal-tracking",
  },
  {
    permission: "GoalType.Read",
    moduleKey: MODULE_KEYS.HRM_PERFORMANCE,
    matches: (path) => path === "/performance/goal-type",
  },
];

export const HRM_TRAINING_ROUTE_RULES = [
  {
    permission: "Training.Read",
    moduleKey: MODULE_KEYS.HRM_TRAINING,
    matches: (path) => path === "/training/training-list",
  },
  {
    permission: "Trainer.Read",
    moduleKey: MODULE_KEYS.HRM_TRAINING,
    matches: (path) => path === "/training/trainers",
  },
  {
    permission: "TrainingType.Read",
    moduleKey: MODULE_KEYS.HRM_TRAINING,
    matches: (path) => path === "/training/training-type",
  },
];

export const HRM_OTHER_ROUTE_RULES = [
  {
    permission: "Promotion.Read",
    moduleKey: MODULE_KEYS.HRM_PROMOTION,
    matches: (path) => path === "/hrm/promotion" || path.startsWith("/hrm/promotion/"),
  },
  {
    permission: "Resignation.Read",
    moduleKey: MODULE_KEYS.HRM_RESIGNATION,
    matches: (path) => path === "/hrm/resignation" || path.startsWith("/hrm/resignation/"),
  },
  {
    permission: "Termination.Read",
    moduleKey: MODULE_KEYS.HRM_TERMINATION,
    matches: (path) => path === "/hrm/termination" || path.startsWith("/hrm/termination/"),
  },
  {
    permission: "Ticket.Read",
    moduleKey: MODULE_KEYS.HRM_TICKETS,
    matches: (path) => path.startsWith("/tickets/"),
  },
  {
    permission: "Holiday.Read",
    moduleKey: MODULE_KEYS.HRM_HOLIDAYS,
    matches: (path) => path === "/hrm/holidays" || path.startsWith("/hrm/holidays/"),
  },
];

export const HRM_ROUTE_RULES = [
  ...HRM_EMPLOYEE_ROUTE_RULES,
  ...HRM_PAYROLL_ROUTE_RULES,
  ...HRM_ATTENDANCE_ROUTE_RULES,
  ...HRM_PERFORMANCE_ROUTE_RULES,
  ...HRM_TRAINING_ROUTE_RULES,
  ...HRM_OTHER_ROUTE_RULES,
];

function permissionForMenu(map, menuValue) {
  return map[menuValue] || null;
}

export function isHrmEmployeeMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(HRM_EMPLOYEE_MENU_PERMISSIONS, menuValue);
}

export function isHrmPayrollMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(HRM_PAYROLL_MENU_PERMISSIONS, menuValue);
}

export const HRM_PAYROLL_COMPANY_SETTINGS_MENU = "Payroll Company Settings";
export const HRM_MY_PAYROLL_MENU = "My Payroll";
export const HRM_EMPLOYEE_DOCUMENTS_MENU = "Documents";

export function isHrmPayrollCompanySettingsMenu(menuValue) {
  return (
    menuValue === HRM_PAYROLL_COMPANY_SETTINGS_MENU ||
    menuValue === "Payroll Company Setup" ||
    menuValue === "Payroll"
  );
}

export function isHrmMyPayrollMenu(menuValue) {
  return menuValue === HRM_MY_PAYROLL_MENU;
}

export function isHrmEmployeeDocumentsMenu(menuValue) {
  return menuValue === HRM_EMPLOYEE_DOCUMENTS_MENU;
}

export function isHrmPayrollParentMenu(menuValue) {
  return isHrmPayrollCompanySettingsMenu(menuValue) || isHrmMyPayrollMenu(menuValue);
}

export function isHrmAttendanceMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(HRM_ATTENDANCE_MENU_PERMISSIONS, menuValue);
}

export function isHrmPerformanceMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(HRM_PERFORMANCE_MENU_PERMISSIONS, menuValue);
}

export function isHrmTrainingMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(HRM_TRAINING_MENU_PERMISSIONS, menuValue);
}

export function isHrmTicketsMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(HRM_TICKETS_MENU_PERMISSIONS, menuValue);
}

export function isHrmSingleMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(HRM_SINGLE_MENU_PERMISSIONS, menuValue);
}

export function canShowHrmEmployeeMenuForEmployee(menuValue, hasPermission) {
  const permission = permissionForMenu(HRM_EMPLOYEE_MENU_PERMISSIONS, menuValue);
  return permission ? hasPermission(permission) : false;
}

export function canShowHrmPayrollMenuForEmployee(menuValue, hasPermission) {
  const permission = permissionForMenu(HRM_PAYROLL_MENU_PERMISSIONS, menuValue);
  if (!permission) return false;
  if (permission === "Payroll.ReadSelf") {
    return hasPermission("Payroll.ReadSelf") || hasPermission("Payroll.Read");
  }
  return hasPermission(permission);
}

export function canShowHrmAttendanceMenuForEmployee(menuValue, hasPermission) {
  const permission = permissionForMenu(HRM_ATTENDANCE_MENU_PERMISSIONS, menuValue);
  return permission ? hasPermission(permission) : false;
}

export function canShowHrmAttendanceMenuForPureEmployee(menuValue, hasPermission, options = {}) {
  if (menuValue === "Leaves (Admin)" && options.isLineManager) {
    return true;
  }

  if (isHrmAttendanceAdminOnlyMenu(menuValue)) {
    return false;
  }

  return canShowHrmAttendanceMenuForEmployee(menuValue, hasPermission);
}

export function canShowHrmPerformanceMenuForEmployee(menuValue, hasPermission) {
  const permission = permissionForMenu(HRM_PERFORMANCE_MENU_PERMISSIONS, menuValue);
  return permission ? hasPermission(permission) : false;
}

export function canShowHrmTrainingMenuForEmployee(menuValue, hasPermission) {
  const permission = permissionForMenu(HRM_TRAINING_MENU_PERMISSIONS, menuValue);
  return permission ? hasPermission(permission) : false;
}

export function canShowHrmTicketsMenuForEmployee(menuValue, hasPermission) {
  const permission = permissionForMenu(HRM_TICKETS_MENU_PERMISSIONS, menuValue);
  return permission ? hasPermission(permission) : false;
}

export function canShowHrmSingleMenuForEmployee(menuValue, hasPermission) {
  const permission = permissionForMenu(HRM_SINGLE_MENU_PERMISSIONS, menuValue);
  return permission ? hasPermission(permission) : false;
}

export function matchHrmRoute(path) {
  if (!path) return null;
  return HRM_ROUTE_RULES.find((rule) => rule.matches(path)) || null;
}

export function canAccessHrmRoute(path, hasPermission, options = {}) {
  const rule = matchHrmRoute(path);
  if (!rule) return false;
  if (options.isPureEmployee && rule.adminOnly) {
    const managerLeavesAdmin = options.isLineManager && path === "/leave/leaves-admin";
    if (!managerLeavesAdmin) return false;
  }
  if (options.isLineManager && path === "/leave/leaves-admin") {
    return true;
  }
  if (rule.permission === "Payroll.ReadSelf") {
    return hasPermission("Payroll.ReadSelf") || hasPermission("Payroll.Read");
  }
  return hasPermission(rule.permission);
}

export function canAccessHrmRoutes(hasPermission) {
  return HRM_ROUTE_RULES.some((rule) => hasPermission(rule.permission));
}
